import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  HostBinding,
} from '@angular/core';

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  @HostBinding('class') class = 'col';
  @HostBinding('class.first') get classFirst(): boolean {
    return this.isFirst;
  }
  @HostBinding('class.last') get classLast(): boolean {
    return this.isLast;
  }

  @Input() isActive: boolean;
  @Input() tabKey: string;
  @Input() isFirst: boolean;
  @Input() isLast: boolean;
  @Input() tabText?: string;
  @Output() tabClick = new EventEmitter<string>();
}
